module.exports = __webpack_public_path__ + "static/media/ep4.b7b1b6ca.png";